export enum HoursSource {
	HoursInput = 1,
	ClockInOut = 2,
	HoursRequest = 3,
	HoursImport = 4,
	Calendar = 5,
	LSHoursEntry = 6,
}
